// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otpGroup_SQNAA {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin: 24px 0;
}

.otpInput_Ku8oL {
  width: 40px;
  height: 40px;
  border: 1px solid var(--e0-border);
  border-radius: 8px;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #162d3a;
  background-color: #f8f9fa;
}

.otpInput_Ku8oL:focus {
  outline: none;
  border-color: #162d3a;
  background-color: var(--white-background);
}

@media (max-width: 480px) {
  .otpInput_Ku8oL {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/OtpInput/OtpInput.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".otpGroup {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  margin: 24px 0;\n}\n\n.otpInput {\n  width: 40px;\n  height: 40px;\n  border: 1px solid var(--e0-border);\n  border-radius: 8px;\n  text-align: center;\n  font-size: 18px;\n  font-weight: 500;\n  color: #162d3a;\n  background-color: #f8f9fa;\n}\n\n.otpInput:focus {\n  outline: none;\n  border-color: #162d3a;\n  background-color: var(--white-background);\n}\n\n@media (max-width: 480px) {\n  .otpInput {\n    width: 36px;\n    height: 36px;\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"otpGroup": `otpGroup_SQNAA`,
	"otpInput": `otpInput_Ku8oL`
};
export default ___CSS_LOADER_EXPORT___;
